import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  LoginScreen,
  ChangePasswordScreen,
  ForgotPasswordScreen,
} from '../modules/Rider/Auth';
import ProfileScreen from '../modules/Rider/Profile';
import Home from '../modules/Rider/Home';
import Logistics from '../modules/Logistics';
import LogisticsHistory from '../modules/Logistics/History';
import CollectOrderStepsScreen from '../modules/Logistics/OrderCollection';
import NotFoundPage from '../Components/NotFound';

const WebRoutes = ({ locationCoordinates }) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/logistics"
          element={<Logistics locationCoordinates={locationCoordinates} />}
        />
        <Route path="/" exact element={<Home />} />
        <Route path="/forgot_password" element={<ForgotPasswordScreen />} />
        <Route path="/change_password" element={<ChangePasswordScreen />} />
        <Route path="/create_password" element={<ChangePasswordScreen />} />
        <Route path="/profile" element={<ProfileScreen />} />
        <Route path="/collect_order" element={<CollectOrderStepsScreen />} />
        <Route path="/logistics_history" element={<LogisticsHistory />} />
        <Route path="/login" exact element={<LoginScreen />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};
WebRoutes.propTypes = {
  locationCoordinates: PropTypes.object,
};
export default WebRoutes;
